<template>
  <automation-exports-list />
</template>

<script>
import AutomationExportsList from '@/modules/automations/components/AutomationExportsList'
export default {
  name: 'ExportsTab',
  components: { AutomationExportsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/automations/pages/ExportsTab.vue